/* eslint-disable prefer-const,import/no-mutable-exports */
/**
 * Profile
 * @type {boolean}
 */
export let debug = process.env.NODE_ENV === 'development';
